<script>
import {ConcernElements} from "@/views/product/components/product-card";
import Overlay from "@core/components/common/Overlay.vue";

export default {
    components: {Overlay, ConcernElements},
    props: {
        product: {
            required: true
        },
        request: {
            required: true
        },
        includedSubstances: {
            default() {
                return [];
            }
        },
        excludedSubstances: {
            default() {
                return [];
            }
        },
        loading: {
            default: false
        },
        showQuestions: {
            default: false
        },
    },

    data() {
        return {
            showLoading: true
        }
    },

    computed: {
        productStatementAnswers() {
            const complex = this.request.isComplexProduct === true
                || this.product.isComplex === true
                || (this.request.product && this.request.product.isComplex === true);
            if (complex) return null;

            return Array.isArray(this.product.productStatementAnswers)
                ? this.product.productStatementAnswers
                : [];
        },
        legislations() {
            return this.request.legislations.map(l => l.id);
        },
        autoExpandLists() {
            return this.request.legislations.length === 1;
        },
        autoExpandSubstances() {
            return this.request.legislations.length === 1;
        }
    },

    created() {
        this.$emit('validityChanged', true);
    }
}
</script>

<template>
    <Overlay :show="showLoading || loading">
        <ConcernElements
            :product="product"
            :product-statement-answers="productStatementAnswers"
            :show-information-owner-settings="false"
            :company-has-information="true"
            :legislations="legislations"
            :show-instruction="false"
            :show-questions="showQuestions"
            :auto-expand-lists="autoExpandLists"
            :auto-expand-substances="autoExpandSubstances"
            container-class=""
            :included-substances="includedSubstances"
            :excluded-substances="excludedSubstances"
            @include="(s) => $emit( 'include', s)"
            @exclude="(s) => $emit( 'exclude', s)"
            @undefined="(s) => $emit( 'undefined', s)"
            @loaded="showLoading = false"
            @listQuestionStateUpdated="(list, state) => $emit('listQuestionStateUpdated', list, state)"
        />
    </Overlay>
</template>
